import { render, staticRenderFns } from "./ResponderSolicitudes.vue?vue&type=template&id=42b123e6&scoped=true&"
import script from "./ResponderSolicitudes.vue?vue&type=script&lang=js&"
export * from "./ResponderSolicitudes.vue?vue&type=script&lang=js&"
import style0 from "./ResponderSolicitudes.vue?vue&type=style&index=0&id=42b123e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b123e6",
  null
  
)

export default component.exports